import { AfpantIntentionMessage } from "@/components/AfpantIntentionMessage/AfpantIntentionMessage";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated-user/superuser/afpant/$orgNumber/intensjonsmelding/$intentionMessageId/",
)({
  loader: async ({ params }) => {
    const { orgNumber, intentionMessageId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["intention-message"][
      ":intentionMessageId"
    ].$get({
      param: {
        orgNumber,
        intentionMessageId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch intention message");
    }

    return {
      message: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Intensjonsmelding | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { orgNumber } = Route.useParams();
  const { message } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Intensjonsmelding</DocumentTitle>

      <AfpantIntentionMessage
        orgNumber={orgNumber}
        message={message.afpant_intention_message}
        responses={message.afpant_intention_message_response}
      />
    </>
  );
}
